export default __webpack_public_path__ + "static/media/warrior.8b4577b2.png";